import DOMPurify from 'dompurify';

export const sanitize = (input: string | Node) => {
  return DOMPurify.sanitize(input, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['rel', 'target'],
  });
};
